import {
  GET_LEAD_FORM_FAIL,
  GET_LEAD_FORM_REQUEST,
  GET_LEAD_FORM_SUCCESS,
  LEAD_FORM_SUBMIT_FAIL,
  LEAD_FORM_SUBMIT_REQUEST,
  LEAD_FORM_SUBMIT_SUCCESS,
} from "../constant";

const initialState = {
  isLoading: false,
  leadFormData: [],
  ss_id: "",
};

const leadFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_FORM_REQUEST:
      return {
        ...state,
        isLoading: true,
        leadFormData: [],
      };
    case GET_LEAD_FORM_SUCCESS:
      const sortedFields = action?.payload?.sort(
        (a, b) => Number(a.su_order) - Number(b.su_order)
      );
      console.log("sortedFields", sortedFields);
      return {
        ...state,
        isLoading: false,
        leadFormData: [...sortedFields],
      };
    case GET_LEAD_FORM_FAIL:
      return {
        ...state,
        isLoading: false,
        leadFormData: [],
      };
    case LEAD_FORM_SUBMIT_REQUEST:
      return state;
    case LEAD_FORM_SUBMIT_SUCCESS:
      return {
        ...state,
        ss_id: action?.payload,
      };
    case LEAD_FORM_SUBMIT_FAIL:
      return state;
    default:
      return state;
  }
};

export default leadFormReducer;
